"use client";

import { usePathname } from "next/navigation";
import { ROUTES } from "@lib/routes";
import { AgentChatWidget } from "./AgentChatWidget";

/**
 * Keeps the floating tutor launcher off the first-run wizard, which owns its own
 * chrome. The widget runs several hooks, so it is gated here rather than with an
 * early return inside it (that would change the hook order across routes).
 */
export function AgentChatWidgetSlot({
  aiConsentRequired = false,
}: {
  /** CMP-01, resolved on the server. See the widget for why it is not a client read. */
  aiConsentRequired?: boolean;
}) {
  const pathname = usePathname();
  // Guided checks expose assistance through their acknowledged hint action.
  // An untracked tutor answer would contaminate independent-use evidence.
  if (pathname === ROUTES.onboarding || pathname?.startsWith("/learn/") || pathname === "/recall")
    return null;
  return <AgentChatWidget aiConsentRequired={aiConsentRequired} />;
}
